module.exports = __webpack_public_path__ + "static/img/200142.15aad677.png";